interface HeaderProps {
  logo?: string | null;
}

const Header = ({ logo }: HeaderProps) => {
  return (
    <header className="app-header">
      {logo && (
        <button className="app-header-logo">
          <img src={logo} alt="primepass" />
        </button>
      )}
    </header>
  )
}

export default Header;